import * as Yup from 'yup'
import LookupType from './LookupType'

const noTakeOffFormFinishSelectionErrorMessage = `"Take Off Form and Finish" selection required`

const GuniteWorkOrderRaisedBeam = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderWingWall = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderPlantarWall = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderRetainingWall = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderPoolOutOfGround = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderCrewMember = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    employee_id: Yup.number().nullable(),
    employee_name: Yup.string().nullable()
})

export const GuniteWorkOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_id: Yup.number().nullable(),
    job_detail_id: Yup.number().nullable(),
    work_order_job_number: Yup.number().nullable(),
    invoice_number: Yup.string().max(20).nullable(),
    date: Yup.string().nullable(),
    company: LookupType.nullable(),
    company_supervisor: LookupType.nullable(),
    job_name: Yup.string().nullable(),
    crew: LookupType.nullable(),
    foreman: LookupType.nullable(),
    property_owner: LookupType.nullable(),
    address_line_1: Yup.string().nullable(),
    address_line_2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    county: Yup.string().nullable(),
    key_map: Yup.string().nullable(),
    is_no_spa: Yup.boolean(),
    is_spa_only: Yup.boolean(),
    is_separate_spa: Yup.boolean(),
    spa_raised_low: Yup.string().nullable(),
    spa_raised_mid: Yup.string().nullable(),
    spa_raised_high: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage),
    spa_wall_length: Yup.string().nullable(),
    spa_wall_thickness: Yup.string().nullable(),
    is_custom_spa: Yup.boolean(),
    is_deepend_spa: Yup.boolean(),
    is_rolled_beam_spa: Yup.boolean(),
    estimated_perimeter: Yup.string().nullable(),
    actual_perimeter: Yup.string().nullable(),
    is_walk_out_steps: Yup.boolean(),
    is_swimout: Yup.boolean().nullable(), //deprecated/hidden field
    is_sunshelf: Yup.boolean(),
    is_beach_entry: Yup.boolean(),
    benches: Yup.string().nullable(),
    total_steps: Yup.string().nullable(),
    is_flashed: Yup.boolean(),
    is_deep_end_ramp: Yup.boolean(),
    waterfall_pad_low: Yup.string().nullable(),
    waterfall_pad_mid: Yup.string().nullable(),
    waterfall_pad_high: Yup.string().nullable(),
    fountain_pad_low: Yup.string().nullable(),
    fountain_pad_mid: Yup.string().nullable(),
    fountain_pad_high: Yup.string().nullable(),
    notch_beam_low: Yup.string().nullable(),
    notch_beam_mid: Yup.string().nullable(),
    notch_beam_high: Yup.string().nullable(),
    equipment_pad_low: Yup.string().nullable(),
    equipment_pad_mid: Yup.string().nullable(),
    equipment_pad_high: Yup.string().nullable(),
    pool_wall_thickness: Yup.string().nullable(),
    pool_floor_thickness: Yup.string().nullable(),
    depth_low: Yup.string().nullable(),
    depth_mid: Yup.string().nullable(),
    depth_high: Yup.string().nullable(),
    raised_beams: Yup.array().of(GuniteWorkOrderRaisedBeam).nullable(),
    wing_walls: Yup.array().of(GuniteWorkOrderWingWall).nullable(),
    plantar_walls: Yup.array().of(GuniteWorkOrderPlantarWall).nullable(),
    retaining_walls: Yup.array().of(GuniteWorkOrderRetainingWall).nullable(),
    pool_out_of_ground: Yup.array().of(GuniteWorkOrderPoolOutOfGround).nullable(),
    skimmers: Yup.string().nullable(),
    lights: Yup.string().nullable(),
    steel: Yup.string().nullable(),
    is_skimmer_in_ramp: Yup.boolean(),
    muck_out_time: Yup.string().nullable(),
    yards: Yup.string().nullable(),
    pegboard: Yup.string().nullable(),
    extras: Yup.string().nullable(),
    free_form: Yup.string().nullable(),
    is_slide: Yup.boolean(),
    is_grotto: Yup.boolean(),
    is_gunited: Yup.boolean(),
    boulder_creations_yardage: Yup.string().nullable(),
    is_ayudo: Yup.boolean(),
    is_no_ayudo: Yup.boolean(),
    is_ayudo_poco: Yup.boolean(),
    is_ayudo_mucho: Yup.boolean(),
    flash_yards: Yup.string().nullable(),
    total_yards: Yup.string().nullable(),
    gate_code: Yup.string().nullable(),
    foreman_notes: Yup.string().nullable(),
    crew_members: Yup.array().of(GuniteWorkOrderCrewMember).nullable(),
})